import { Inject, Injectable, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GungLanguageConfigService } from 'gung-common';
import {
  AuthService,
  CartService,
  GungAnonymousConfigService,
  GungCurrencyPipe,
  PriceConfigService,
  PriceService,
  ProductService
} from 'gung-standard';
import { first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CultPriceConfigService extends PriceConfigService {
  constructor(
    protected currencyPipe: GungCurrencyPipe,
    protected cartService: CartService,
    protected priceService: PriceService,
    protected productService: ProductService,
    protected authService: AuthService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
    protected translateService: TranslateService,
    protected languageConfigService: GungLanguageConfigService
  ) {
    super(
      currencyPipe,
      cartService,
      priceService,
      productService,
      authService,
      gungAnonymousConfigService,
      translateService,
      languageConfigService
    );
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => this.hidePrice.next(roles.indexOf('RETUR_NOPRICE') >= 0));
  }
}
